"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppState = void 0;
const store_1 = require("@completeanatomy/store");
const typedi_1 = require("typedi");
/**
 * Returns current AppState state with readonly modifier
 *
 * @return Readonly<Partial<AppState>>
 */
function getAppState() {
    const store = typedi_1.Container.get(store_1.StoreToken);
    return store.getState();
}
exports.getAppState = getAppState;
